export const getEnvVar = (name) => import.meta.env[name];

export const getFirebaseEnvVar = (name) => getEnvVar(`VITE_FIREBASE_${name}`);
